var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card-inside-container" }, [
    _c(
      "div",
      {
        key: _vm.annonce.serverId,
        staticClass: "card last-annonce-card d-flex flex-row",
        on: {
          click: function($event) {
            return _vm.goToAnnonce(_vm.annonce.serverId)
          }
        }
      },
      [
        _c("div", { staticClass: "position-relative" }, [
          _vm.annonce.vehicle.imagesVehicle.length > 0 && _vm.mainImageUrl
            ? _c("img", {
                staticClass: "card-img-left",
                attrs: { src: _vm.mainImageUrl }
              })
            : _c("img", {
                staticClass: "card-img-left",
                attrs: { src: require("@/assets/images/b122/PLACEHOLDER.png") }
              }),
          _vm._v(" "),
          _vm.AnnonceUtils.isBoostStillValid(_vm.annonce.boostEndDate)
            ? _c("div", { staticClass: "boost-icon-container" }, [
                _c("i", { staticClass: "ph-lightning-fill" })
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "body-annonce pl-2 ml-0" }, [
          _c("div", { staticClass: "d-flex flex-column mb-2" }, [
            _c(
              "div",
              _vm._l(5, function(index) {
                return _c("i", {
                  class:
                    (index <= _vm.annonce.additionnalRewardLevel
                      ? "ph-star-fill"
                      : "ph-star") + " main-color"
                })
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "card-title-annonce vehicle-name mb-1" }, [
              _vm._v(_vm._s(_vm.annonce.vehicle.annonceName))
            ]),
            _vm._v(" "),
            !_vm.fromMyAnnonce
              ? _c("div", { staticClass: "d-flex mb-1" }, [
                  _c("i", {
                    staticClass:
                      "ph-custom ph-clock-counter-clockwise main-color"
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "relative-date ml-2" }, [
                    _vm._v(
                      _vm._s(
                        _vm.convertTimestampToRelativeDate(_vm.annonce.date)
                      )
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex mb-1" }, [
              _c("i", { staticClass: "ph-custom ph-scan main-color" }),
              _vm._v(" "),
              _c("span", { staticClass: "relative-date ml-2" }, [
                _vm._v(_vm._s(_vm.getPlate(_vm.annonce.vehicle)))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex" }, [
              _c("i", { staticClass: "ph-custom ph-map-trifold main-color" }),
              _vm._v(" "),
              !_vm.fromMyAnnonce
                ? _c(
                    "span",
                    { staticClass: "relative-date location-row ml-2" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.getLocation(_vm.annonce.vehicle.theftPosition)
                        )
                      )
                    ]
                  )
                : _vm.fromMyAnnonce
                ? _c(
                    "span",
                    { staticClass: "relative-date location-row ml-2" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.getLocationExact(
                            _vm.annonce.vehicle.theftPosition
                          )
                        )
                      )
                    ]
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex justify-content-between" }, [
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _vm.annonce.annonceFavorite
                ? _c(
                    "svg",
                    {
                      attrs: {
                        fill: "none",
                        height: "19",
                        viewBox: "0 0 13 11",
                        width: "19",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M12.225 3.77344C12.225 7.32812 6.9384 10.2054 6.71326 10.3242C6.65392 10.356 6.5876 10.3727 6.52022 10.3727C6.45284 10.3727 6.38651 10.356 6.32717 10.3242C6.10204 10.2054 0.81543 7.32812 0.81543 3.77344C0.816373 2.93871 1.14939 2.13844 1.74143 1.5482C2.33347 0.957952 3.13617 0.625941 3.97344 0.625C5.02526 0.625 5.94617 1.07594 6.52022 1.83816C7.09426 1.07594 8.01518 0.625 9.067 0.625C9.90426 0.625941 10.707 0.957952 11.299 1.5482C11.891 2.13844 12.2241 2.93871 12.225 3.77344Z",
                          fill: "#E74A49"
                        }
                      })
                    ]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            !_vm.fromMyAnnonce
              ? _c(
                  "div",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-between"
                  },
                  [
                    _c("div"),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "view-label",
                        class: _vm.annonce.userHasSeenAnnonce
                          ? "seen-annonce"
                          : "not-seen-annonce"
                      },
                      [
                        _vm.annonce.nbViews > 122
                          ? _c("div", [
                              _c("span", { staticClass: "ml-1" }, [
                                _vm._v(_vm._s(_vm.annonce.nbViews))
                              ])
                            ])
                          : _c("div", [
                              _c("span", { staticClass: "ml-1" }, [
                                _vm._v(_vm._s(_vm.$t("new.annonce")))
                              ])
                            ]),
                        _vm._v(" "),
                        _c(
                          "svg",
                          {
                            staticClass: "mr-1",
                            attrs: {
                              fill: "none",
                              height: "19",
                              viewBox: "0 0 19 19",
                              width: "19",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d:
                                  "M18.1595 9.27219C18.1349 9.21664 17.5393 7.89547 16.2153 6.57148C14.4512 4.80734 12.223 3.875 9.7705 3.875C7.318 3.875 5.0898 4.80734 3.32566 6.57148C2.00167 7.89547 1.40331 9.21875 1.38152 9.27219C1.34953 9.34413 1.33301 9.42198 1.33301 9.5007C1.33301 9.57943 1.34953 9.65728 1.38152 9.72922C1.40613 9.78477 2.00167 11.1052 3.32566 12.4292C5.0898 14.1927 7.318 15.125 9.7705 15.125C12.223 15.125 14.4512 14.1927 16.2153 12.4292C17.5393 11.1052 18.1349 9.78477 18.1595 9.72922C18.1915 9.65728 18.208 9.57943 18.208 9.5007C18.208 9.42198 18.1915 9.34413 18.1595 9.27219ZM9.7705 12.3125C9.21424 12.3125 8.67047 12.1475 8.20796 11.8385C7.74545 11.5295 7.38496 11.0902 7.17209 10.5763C6.95922 10.0624 6.90352 9.49688 7.01204 8.95131C7.12056 8.40574 7.38843 7.9046 7.78176 7.51126C8.1751 7.11793 8.67624 6.85006 9.22181 6.74154C9.76738 6.63302 10.3329 6.68872 10.8468 6.90159C11.3607 7.11446 11.8 7.47495 12.109 7.93746C12.4181 8.39997 12.583 8.94374 12.583 9.5C12.583 10.2459 12.2867 10.9613 11.7592 11.4887C11.2318 12.0162 10.5164 12.3125 9.7705 12.3125Z",
                                fill: "black"
                              }
                            })
                          ]
                        )
                      ]
                    )
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.fromMyAnnonce
            ? _c(
                "div",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-between"
                },
                [
                  _vm.annonce.status &&
                  _vm.annonce.status.value === "DRAFT" &&
                  !_vm.annonce.askedToBeDeleted
                    ? _c("div", { staticClass: "d-flex align-items-center" }, [
                        _c("i", { staticClass: "ph-custom ph-pen" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "relative-date ml-2" }, [
                          _vm._v(_vm._s(_vm.$t("annonce.modify.Draft")))
                        ])
                      ])
                    : _vm.annonce.status &&
                      _vm.annonce.status.value === "REFUSED"
                    ? _c("div", { staticClass: "d-flex align-items-center" }, [
                        _c("i", {
                          staticClass: "ph-custom ph-x-circle main-red-color"
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "refused ml-2 main-red-color" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("annonce.refused.draft.content", {
                                  content: _vm.annonce.commentaire
                                    ? _vm.annonce.commentaire
                                    : ""
                                })
                              )
                            )
                          ]
                        )
                      ])
                    : _vm.annonce.status &&
                      _vm.annonce.status.value === "TO_VALIDATE"
                    ? _c("div", { staticClass: "d-flex align-items-center" }, [
                        _c("i", {
                          staticClass: "ph-custom ph-hourglass-high orange"
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "refused ml-2 orange" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("annonce.my.ongoing.validation.annonce")
                            )
                          )
                        ])
                      ])
                    : _vm._e()
                ]
              )
            : _vm._e()
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12b7c066", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12b7c066","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/annonce/AnnonceCardImageLeft.vue
// module id = TWiu
// module chunks = 0